






























import { dayjs, D_FORMAT_INPUT, DT_FORMAT_INPUT, DTW_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import { LessonsService } from '../../biz/remote/LessonsService';
import { Session } from '../../utils/Session';
import { routeHelper } from '../../utils/routeHelper';

@Component({
  filters: {
    dateFormat(value: string): string {
      if (!value) return '';
      return dayjs(value).format(DTW_FORMAT_JA);
    },
  },
})
export default class TeacherDailyReportListPage extends Vue {
  private date = dayjs().format(D_FORMAT_INPUT);
  private lessons: LessonDTO[] = [];

  async created() {
    await this.loadData();
  }

  @Watch('date')
  async loadData() {
    console.log('load');
    const target = dayjs(this.date);
    const from = target.format(DT_FORMAT_INPUT);
    const to = target.endOf('date').format(DT_FORMAT_INPUT);

    const biz = new LessonsService();
    const response = await biz.getLessonsStateForTeacher(Session.getSessionUserId(), from, to);
    if (response.hasError) {
      MessageDialog.alert(response.errorDescription);
      return;
    }
    this.lessons = response.data;
  }

  gotoDailyReport(row: LessonDTO) {
    if (!row.lessons?.class_id) {
      MessageDialog.systemError('レッスンID', '日報への遷移時', row.lessons?.class_id).then();
      return;
    }
    routeHelper(this, 'TeacherDailyReportPage', { class_id: row.lessons?.class_id.toString() });
  }

  sendTo(row: LessonDTO) {
    console.log('send', row);
  }
}
